<template lang="html">
    <router-link :to="link" class="addNewSomething">
      <div class="addNewSomething_content">
        <img :src="require('@/assets/plus.svg')" alt=""/>
        <span>{{text}}</span>
      </div>

    </router-link>
</template>

<script>
export default {
  name: "AddSomeThingLink",
  props: ["link","text"]
}
</script>

<style lang="css" scoped>
.addNewSomething{
display: inline-block;
}
.addNewSomething_content{
  background: #3783C5 0% 0% no-repeat padding-box;
border-radius: 50px;
padding: 13px 22px;
font-size: 14px;
line-height: 17px;
color: #FFF;
display:flex;
justify-content: center;
align-items: center;
}
.addNewSomething_content img{
  width: 15px;
  margin-right: 10px;
}
</style>
